import { CheckCircle2 } from "lucide-react";
import ServiceIcon from "./ServiceIcon";
import { SITE } from "../lib/site";
import { Reveal } from "./Reveal";

export default function WhatToBring() {
  const { universal, scenarios } = SITE.whatToBring;
  return (
    <section
      className="py-24 md:py-32 lg:py-40 bg-white border-t border-[#0A192F]/10"
      data-testid="what-to-bring"
    >
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14">
        <div className="lg:col-span-4">
          <div className="label-mini">04 · What to Bring</div>
          <h2 className="font-serif mt-5 md:mt-6 text-4xl sm:text-5xl md:text-6xl leading-[1.02] text-[#0A192F]">
            Come prepared. <span className="italic text-[#C5A059]">Leave faster.</span>
          </h2>
          <p className="mt-6 text-[#0A192F]/70 max-w-md leading-relaxed">
            Bring these documents and your visit takes minutes — not hours.
            Not sure? Call ahead and we'll tell you exactly what applies to your case.
          </p>

          <div className="mt-10">
            <div className="label-mini text-[#C5A059]">Every visit</div>
            <ul className="mt-4 space-y-3">
              {universal.map((d) => (
                <li key={d} className="flex items-start gap-3 text-[#0A192F]/85 text-[15px]">
                  <CheckCircle2 className="w-5 h-5 text-[#C5A059] mt-0.5 shrink-0" strokeWidth={1.5} />
                  <span>{d}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="lg:col-span-7 lg:col-start-6 grid sm:grid-cols-2 gap-4 md:gap-5">
          {scenarios.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div
                className="border border-[#0A192F]/12 p-6 md:p-7 h-full bg-[#FBF9F5] hover:border-[#C5A059]/50 hover:bg-white transition-colors duration-500"
                data-testid={`what-bring-${i}`}
              >
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full border border-[#0A192F]/15 text-[#C5A059] flex items-center justify-center">
                    <ServiceIcon name={s.icon} className="w-4 h-4" />
                  </span>
                  <h3 className="font-serif text-xl md:text-2xl text-[#0A192F]">
                    {s.title}
                  </h3>
                </div>
                <ul className="mt-5 space-y-2.5 text-sm text-[#0A192F]/75">
                  {s.docs.map((d) => (
                    <li key={d} className="flex items-start gap-2">
                      <span className="mt-2 w-1 h-1 rounded-full bg-[#C5A059] shrink-0" />
                      <span>{d}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
